import React, { Component } from 'react';
import $ from 'jquery';

import ServicesHeader from '../Components/ServicesHeader';
import Footer from '../Components/ServicesFooter';
import Services from '../Components/Services';

class ServicePage extends Component {

    constructor(props) {
        super(props);
        this.state = {
            siteData: {}
        };

    }

    getSiteData() {
        $.ajax({
            url: 'siteData.json',
            dataType: 'json',
            cache: false,
            success: function (data) {
                this.setState({ siteData: data });
            }.bind(this),
            error: function (xhr, status, err) {
                console.log(err);
            }
        });
    }

    componentDidMount() {
        this.getSiteData();
    }

    render() {
        return (
            <div className="App">
                <ServicesHeader data={this.state.siteData.main} />
                <Services data={this.state.siteData.main} />
                <Footer data={this.state.siteData.main} />
            </div>
        );
    }
};

export default ServicePage;